const toNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const mapFineRows = (fines = []) =>
  fines.map((fine) => ({
    id: fine.id,
    apartment: fine.apartment?.number || fine.apartmentId,
    concept: fine.concept?.name || "",
    amount: toNumber(fine.amount),
    currency: fine.currency?.name || "",
    date: fine.date,
    account: fine.account?.name || fine.accountingAccount?.name || "",
    attachment: fine.attachmentUrl ? "Si" : "No",
    notifyResident: fine.notifyResident ? "Si" : "No",
    detail: fine.detail,
  }));

export const totalsByCurrency = (fines = []) => {
  const accumulator = new Map();

  fines.forEach((fine) => {
    const currencyName = fine.currency?.name || fine.currencyId || "";
    if (!currencyName) return;
    const current = accumulator.get(currencyName) || 0;
    accumulator.set(currencyName, current + toNumber(fine.amount));
  });

  return Array.from(accumulator.entries()).map(([currency, amount]) => ({
    currency,
    amount,
  }));
};

